export const ERROR_MESSAGE_SCREEN = {
  NO_CONTACTS: 'No Referrals',
  NO_APPOINTMENTS: 'No Appointments',
  NO_NOTIFICATIONS: 'No Notifications',
  NO_TASKS: 'No Tasks'
};
